import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type OwnershipStatus = APIResponse<'/api/v4/ownership-statuses'>[number];

export const fetchOwnershipStatus = () =>
  get<OwnershipStatus[]>('/v4/ownership-statuses');
